import { useState } from "react";
import { T } from "../theme";

export default function Card({ children, padding = T.cardPadding, hover = false, noPadding = false, style }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={hover ? () => setHovered(true) : undefined}
      onMouseLeave={hover ? () => setHovered(false) : undefined}
      style={{
        background: T.bgCard,
        borderRadius: T.radius,
        border: `1px solid ${T.border}`,
        boxShadow: hovered ? T.cardShadowHover : T.shadowCard,
        padding: noPadding ? 0 : padding,
        overflow: noPadding ? "hidden" : undefined,
        transform: hovered ? "translateY(-2px)" : "none",
        transition: T.transitionNormal,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
